<template>
  <section>
    <span
      class="p-1 text-primary clickable"
      style="font-size: 1.2rem"
      v-for="(item, index) in value"
      :key="index"
      v-b-popover.hover.top="item.label"
      @click="onClick(item, index)"
    >
      <i class="mdi" :class="`mdi-${item.icon}`"></i>
      <Component
        v-if="renderComponent(item.click)"
        :is="item.click.component"
        :index="index"
        v-bind="item.click.props"
      />
    </span>
  </section>
</template>

<script>
// Components
// Documents
import DocumentPreview from './documents/Preview.vue'

export default {
  props: {
    value: {
      type: Array,
      required: true
    }
  },
  components: {
    DocumentPreview
  },
  methods: {
    renderComponent (event) {
      return typeof event === 'object' && event.hasOwnProperty('component')
    },
    onClick (event, index) {
      if (event.type === 'redirect') {
        this.$router.push(event.click.to)
      }
      if (event.type === 'modal') {
        this.$bvModal.show(event.click.props.id + index)
      }
      if (event.type === 'download') {
        // URL del archivo PDF
        const urlPDF = `${process.env?.VUE_APP_API_URL}${event.click.to}`

        // Crear un enlace temporal
        const link = document.createElement('a')
        link.href = urlPDF

        // Asignar atributos necesarios para la descarga
        link.download = event.click.fileName

        // Simular el clic en el enlace
        document.body.appendChild(link)
        link.click()

        // Eliminar el enlace del DOM después de la descarga
        document.body.removeChild(link)
      }
    }
  }
}
</script>
